// routes
import Router from './routes';
// theme
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
// components
import ScrollToTop from './components/shared/ScrollToTop';
import LoadingScreen, { ProgressBarStyle } from './components/shared/LoadingScreen';
import ThemePrimaryColor from './components/shared/ThemePrimaryColor';
import NotistackProvider from './components/shared/NotistackProvider';
import useAuth from './hooks/useAuth';


export default function App() {
  const { isInitialized } = useAuth();

  return (
    <ThemeConfig>
      <ThemePrimaryColor>
        <NotistackProvider>
          <GlobalStyles />
          <ProgressBarStyle />
          <ScrollToTop />
          {isInitialized ? <Router /> : <LoadingScreen />}
        </NotistackProvider>
      </ThemePrimaryColor>
    </ThemeConfig>
  );
}
